import { Locale } from '@finxone-platform/shared/enums';

export class GetProjectNotifications {
  static readonly type = '[Project] GetProjectNotifications';
  constructor(public params: { locale: Locale; key: string }, public projectId: string) {}
}
